<template>
  <div class="media-gallery">
    <div v-if="isOnline" class="relative w-100">
      <product-gallery-overlay
        v-if="isZoomOpen"
        :current-slide="currentSlide"
        :product-name="product.name"
        :gallery="gallery"
        @close="toggleZoom"
      />
      <product-gallery-carousel
        :gallery="gallery"
        :configuration="configuration"
        :product-name="product.name"
        @toggle="openOverlay"
        @close="onEscapePress"
        @loaded="carouselLoaded = true"
      />
    </div>
    <product-image
      v-else
      :image="offline"
      :alt="product.name | htmlDecode"
    />
  </div>
</template>

<script>
import { ProductGallery } from '@vue-storefront/core/modules/catalog/components/ProductGallery.ts'
import ProductGalleryOverlay from './ProductGalleryOverlay'
import onEscapePress from '@vue-storefront/core/mixins/onEscapePress'
import ProductImage from './ProductImage'
import { onlineHelper } from '@vue-storefront/core/helpers'

import ProductGalleryCarousel from './ProductGalleryCarousel.vue'

export default {
  components: {
    ProductGalleryCarousel,
    ProductGalleryOverlay,
    ProductImage
  },
  mixins: [
    ProductGallery,
    onEscapePress
  ],
  watch: {
    $route: 'validateRoute'
  },
  data () {
    return {
      isZoomOpen: false,
      currentSlide: 0,
      carouselLoaded: false
    }
  },
  computed: {
    isOnline (value) {
      return onlineHelper.isOnline
    }
  },
  methods: {
    openOverlay (currentSlide) {
      this.currentSlide = currentSlide
      this.toggleZoom()
    },
    validateRoute () {
      this.$forceUpdate()
    },
    toggleZoom () {
      this.isZoomOpen = !this.isZoomOpen
    },
    onEscapePress () {
      if (this.isZoomOpen) {
        this.toggleZoom()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.media-gallery {
  text-align: center;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  min-height: calc(90vw * 1.1);

  @media only screen and (min-width:768px) {
    min-height: inherit;
  }

  &--loaded {
    background-image: none;
  }
}
</style>
